"use strict";

module.exports = {
  bindings: {
    change: '<'
  },
  template: require('./formview-changes.html')
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/treatment-steps-changelog/treatment-steps-changelog.component.js